import PropTypes from "prop-types";
import React from "react";

const SectionTitleWithText = ({ spaceTopClass, spaceBottomClass }) => {
  var strings = require("../../translations/italian.json");
  var informazioni = global.informazioni
  return (
    <div
      className={`welcome-area ${spaceTopClass ? spaceTopClass : ""} ${
        spaceBottomClass ? spaceBottomClass : ""
      }`}
    >
      <div className="container" style={{maxWidth:"1600px"}}>
        <div className="welcome-content text-center" >
          <h5>{informazioni.chisiamoText1}</h5>
          <h1>{informazioni.chisiamoText2}</h1>
          <p dangerouslySetInnerHTML={{__html: informazioni.chisiamoText3}}/>
          <p dangerouslySetInnerHTML={{__html: informazioni.chisiamoText4}}/>
          <p dangerouslySetInnerHTML={{__html: informazioni.chisiamoText5}}/>
          <p dangerouslySetInnerHTML={{__html: informazioni.chisiamoText6}}/>
          <p dangerouslySetInnerHTML={{__html: informazioni.chisiamoText7}}/>
          <p dangerouslySetInnerHTML={{__html: informazioni.chisiamoText8}}/>
          <p dangerouslySetInnerHTML={{__html: informazioni.chisiamoText9}}/>
          <p dangerouslySetInnerHTML={{__html: informazioni.chisiamoText10}}/>
          <p style={{textAlign:"right"}}>
            {informazioni.chisiamoFirma}
          </p>
          <p style={{textAlign:"right"}}>
            {informazioni.chisiamoFirma1}
          </p>
        </div>
      </div>
    </div>
  );
};

SectionTitleWithText.propTypes = {
  spaceBottomClass: PropTypes.string,
  spaceTopClass: PropTypes.string
};

export default SectionTitleWithText;
